import { render, staticRenderFns } from "./productImages.vue?vue&type=template&id=509e9b7f&scoped=true"
import script from "./productImages.vue?vue&type=script&lang=js"
export * from "./productImages.vue?vue&type=script&lang=js"
import style0 from "./productImages.vue?vue&type=style&index=0&id=509e9b7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509e9b7f",
  null
  
)

export default component.exports